import { Badge } from "@mantine/core";
import { humanize } from "../../lib/labels";

// Status → token family (Smart Safiri colour system, "Operational states").
// The theme's variantColorResolver turns these names into the spec's -bg/-fg
// pairs: green=success, yellow/orange=warning, red=error, blue=info,
// steel=fleet accent, oxblood=brand-subtle, gray=offline. Every badge also
// carries its label, so colour is never the only signal.
const COLOR_BY_STATUS: Record<string, string> = {
  // done / healthy
  approved: "green",
  active: "green",
  completed: "green",
  success: "green",
  SUCCESS: "green",
  COMPLETED: "green",
  online: "green",
  resolved: "green",
  completedFound: "green",
  synced: "green",
  // needs a human
  pending: "yellow",
  PENDING: "yellow",
  underApproval: "yellow",
  documentPending: "yellow",
  documentExpired: "yellow",
  locked: "yellow",
  inProgress: "oxblood", // trip in progress (passenger side)
  // requested / scheduled
  created: "blue",
  searching: "blue",
  PROCESSING: "blue",
  // driver side of the trip — the normal working state, not an alert
  accepted: "steel",
  driverArrived: "steel",
  underTrip: "steel",
  intermediateStopArrived: "oxblood",
  intermediateStopSkipped: "oxblood",
  destinationArrived: "oxblood",
  // neutral / archived
  offline: "gray",
  cancelled: "gray", // routine; driver-caused cancellations use warning where known
  completedNotFound: "gray",
  skipped: "gray",
  // failed / blocked
  notFound: "red",
  rejected: "red",
  suspended: "red",
  banned: "red",
  failed: "red",
  FAILED: "red",
  deleted: "red",
  active_sos: "red",
  // referral program: tiers, referrals, agents, review flags
  paid: "green",
  actioned: "green",
  underReview: "yellow",
  documentsPending: "yellow",
  documentsExpired: "yellow",
  open: "yellow",
  draft: "gray",
  expired: "gray",
  closed: "gray",
  dismissed: "gray",
  reversed: "red",
};

export function StatusBadge({ status }: { status?: string }) {
  if (!status) return <Badge color="gray" variant="light">—</Badge>;
  const color = COLOR_BY_STATUS[status] ?? "gray";
  return (
    <Badge color={color} variant="light" tt="none">
      {humanize(status)}
    </Badge>
  );
}
